import { DEL, GET, POST, PUT, setAuthToken } from "../config/ApiConfig";
import { decryptData, encryptData } from "../helpers/EncryptHelper";
import { apiError } from "../helpers/ErrorHelper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dateFormat from "dateformat";
import config from "../config/config";

const module = {
    endPoint: '/requirements',
    key: 'requirements'
};

export const create = async (user_token, formData) => {
  setAuthToken(user_token);

  return await POST(`${module.endPoint}/add`, formData);
};

export const update = async (user_token, id, formData) => {
  setAuthToken(user_token);

  return await PUT(`${module.endPoint}/update/${id}`, formData);
};

export const remove = async (user_token, id) => {
  setAuthToken(user_token);

  return await DEL(`${module.endPoint}/delete/${id}`);
};

export const saveToStorage = (data, pagination) => {
  if (! config.isCache) {
    return;
  }
  
  let currentTime = dateFormat("", "dd mmm yyyy HH:MM:ss");

  const dataToStore = {
    [module.key]: data,
    pagination: pagination,
    time: currentTime,
  };
  localStorage.setItem(module.key, encryptData(dataToStore));
};

export const getData = async (param = {}) => {
  let user_token = param.user_token;

  if (! user_token) {
    return [];
  }

  let page = param.page ? param.page : 1;
  let limit = param.limit ? param.limit : 10;

  const hasDateRange = !!(param.date_from || param.date_to);

  if (page == 1 && limit == 10 && localStorage.getItem(module.key) && !hasDateRange) {
    return decryptData(localStorage.getItem(module.key));
  }

  delete param.page;
  delete param.limit;
  let query = new URLSearchParams(param).toString();

  try {
    setAuthToken(user_token);

    const url = `${module.endPoint}/list?page=${page}&limit=${limit}&${query}`;
    const response = await GET(url);
    if (! response.status) { 
        toast.error(response.message);
    }

    if (page == 1 && limit == 10 && !hasDateRange) {
        saveToStorage(response.data[module.key], response.data.pagination);
    }

    return response.data;

  } catch (error) {
    apiError(error);

    console.log(error);
  }
};

export const getSelectedSkills = async (user_token, id) => {
  setAuthToken(user_token);

  return await GET(`${module.endPoint}/get-selected-skills/${id}`);
};

export const getView = async (user_token, uniqueId) => {
  if (!user_token || !uniqueId) {
    return null;
  }

  try {
    setAuthToken(user_token);
    const response = await GET(`${module.endPoint}/view/${uniqueId}`);
    if (!response.status) {
      toast.error(response.message);
      return null;
    }

    return response.data?.requirement || response.data;
  } catch (error) {
    apiError(error);
    console.log(error);
    return null;
  }
};

export const getEligibleCandidates = async (user_token, requirementId, options = {}) => {
  if (!user_token || !requirementId) {
    return { candidates: [], meta: {} };
  }

  const params = new URLSearchParams();
  if (options.limit) {
    params.set("limit", String(options.limit));
  }
  if (options.min_percent != null) {
    params.set("min_percent", String(options.min_percent));
  }

  try {
    setAuthToken(user_token);
    const query = params.toString();
    const url = `${module.endPoint}/eligible-candidates/${requirementId}${query ? `?${query}` : ""}`;
    const response = await GET(url);
    if (!response.status) {
      toast.error(response.message);
      return { candidates: [], meta: {} };
    }

    return {
      candidates: response.data?.eligible_candidates || [],
      meta: response.data?.eligible_candidates_meta || {},
    };
  } catch (error) {
    apiError(error);
    console.log(error);
    return { candidates: [], meta: {} };
  }
};

export const getReport = async(param = {}) => {
  let user_token = param.user_token;

  if (!user_token) {
    return [];
  }

  let page = param.page ? param.page : 1;
  let limit = param.limit ? param.limit : 10;

  delete param.page;
  delete param.limit;
  let query = new URLSearchParams(param).toString();

  try {
    setAuthToken(user_token);

    const url = `${module.endPoint}/report?page=${page}&limit=${limit}&${query}`;
    const response = await GET(url);
    if (!response.status) {
      toast.error(response.message);
    }

    return response.data;

  } catch (error) {
    apiError(error);

    console.log(error);
  }
}